import { render, staticRenderFns } from "./points-address-add.vue?vue&type=template&id=3a8241ca&"
import script from "./points-address-add.vue?vue&type=script&lang=js&"
export * from "./points-address-add.vue?vue&type=script&lang=js&"
import style0 from "./points-address-add.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports